var getContrastYIQ = function(color) {
  var hex = '#';
  var r, g, b;
  if (color.indexOf(hex) > -1) {
     r = parseInt(color.substr(0, 2), 16);
     g = parseInt(color.substr(2, 2), 16);
     b = parseInt(color.substr(4, 2), 16);
  } else {
     color = color.match(/\d+/g);
     r = color[0];
     g = color[1];
     b = color[2];
  }

  var yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
  return (yiq >= 128) ? 'black' : 'white';
}



